/* template */
<template><mpx-scroll-view :scroll-y="(true)" class="didi-mall-suggest-list"><mpx-view v-for="(item, index) in (cityList)" :key="item.index" @tap="selectCity(item)" class="didi-mall-suggest-item">{{item.name }}</mpx-view></mpx-scroll-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m216564cb"}'>
.didi-mall-suggest-list
  z-index 0
  width 100%
  height 80%
  .mpx-scroll-view-content
    width 100%
  .didi-mall-suggest-item
    width 686rpx
    box-sizing border-box
    margin 0 32rpx
    font-size 28rpx
    height 100rpx
    line-height 100rpx
    border-bottom 1px solid #e8e9e8
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    cityList: Array,
  },
  methods: {
    selectCity: function(item) {
      this.triggerEvent('citySelect', {
        cityName: item.name,
        cityId: item.id,
      })
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index216564cb",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-scroll-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
